/* eslint-disable react/react-in-jsx-scope */
// import { Cell, Pie, PieChart, ResponsiveContainer, Tooltip } from "recharts";
import {
  ComposedChart,
  Line,
  Area,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from 'recharts';

import "./pieChartBox.css";

const data = [
  { name: "Mobile", value: 400, color: "#0088FE" },
  // { name: "Desktop", value: 300, color: "#00C49F" },
  // { name: "Laptop", value: 300, color: "#FFBB28" },
  // { name: "Tablet", value: 200, color: "#FF8042" },
];

type Props = {
  color: string;
  icon: string;
  title: string;
  dataKey: string;
  number: number | string;
  percentage: number;
  chartData: object[];
};

const imgurl = `${process.env.REACT_APP_URL}/image/users`


function numberWithCommas (nStr) {
  nStr += '';
    let x = nStr.split('.');
    let x1 = x[0];
    let x2 = x.length > 1 ? '.' + x[1] : '';
    var rgx = /(\d+)(\d{3})/;
    while (rgx.test(x1)) {
        x1 = x1.replace(rgx, '$1' + ',' + '$2');
    }
    x = x1 + x2;
    if(x.substr(0,1) === '.'){
        x = '0' + x;
    }
    return x;
};

const COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042'];

const PieChartBox = (props: Props) => {
  return (
    <div className="pieChartBox">
      <h1>{props.title}</h1>
      <div className="chart">
        <ResponsiveContainer width="100%" height="100%">
          {/* <PieChart>
            <Tooltip
              contentStyle={{ background: "white", borderRadius: "5px" }}
            />
            <Pie
              data={props.chartData}
              cx="50%"
            cy="50%"
              innerRadius={"70%"}
              outerRadius={"90%"}
              fill="#8884d8"
              paddingAngle={5}
              dataKey={props.dataKey}
            >
              {props.chartData.map((item,i) => (
                <Cell key={item.cashier} fill={COLORS[i % COLORS.length]} />
              ))}
            </Pie>
          </PieChart> */}
          <ComposedChart
          // layout="vertical"
          width={500}
          height={400}
          data={props.chartData}
          // margin={{
          //   top: 20,
          //   right: 20,
          //   bottom: 20,
          //   left: 20,
          // }}
        >
          <CartesianGrid stroke="#716e6e" strokeDasharray="3 3" />
          <YAxis type="number" 
            tick={{ fill: '#ffffff' }} tickLine={{ stroke: '#688394' }}
            axisLine={{ stroke: '#EAF0F4' }} 
            style={{
              fontSize: '10px',
              // fontFamily: 'Times New Roman',
            }}
            domain={['auto', 'auto']}
          />
          <XAxis dataKey={props.yaxisKey} type="category" scale="auto"
            tick={{ fill: '#ffffff' }} tickLine={{ stroke: '#688394' }}
            axisLine={{ stroke: '#EAF0F4' }} 
            style={{
              fontSize: '10px',
              // fontFamily: 'Times New Roman',
            }}
          />
            <Tooltip
              contentStyle={{ background: "#2a3447", borderRadius: "5px" }}
              // labelStyle={{ display: "none" }}
              cursor={{fill:"none"}}
            />
          <Legend />
          {/* <Area dataKey="amt" fill="#8884d8" stroke="#8884d8" /> */}
          <Bar dataKey={props.dataKey} barSize={20} fill="#39d820" />
          {/* <Line dataKey="uv" stroke="#ff7300" /> */}
        </ComposedChart>
        </ResponsiveContainer>
      </div>
      <div className="options">
        {props.chartData.map((item) => (
          <div className="option" key={item.cashier}>
            <div className="title">
              <div className="dot"  />
              <img src={`${imgurl}/${item.Avatar}`} alt="" className="w-6 h-6 rounded-full" />
              <span>{item.cashier}</span>
            </div>
            <span>{numberWithCommas(item.total)}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PieChartBox;
